import { DEFAULT_LANG, SUPPORTED_LANGS } from "./config";

export const getUserLanguage = () => {
  return localStorage.getItem("i18nextLng");
};

export const getLanguageFromURL = () => {
  const params = new URLSearchParams(window.location.search);
  const lang = params.get("lang");
  if (!lang) return null;
  const normalized = lang.split("-")[0];
  return SUPPORTED_LANGS.includes(normalized) ? normalized : DEFAULT_LANG;
};

export const getBrowserLanguage = () => {
  const browserLang = navigator.language; // e.g. en-US
  return SUPPORTED_LANGS.includes(browserLang) ? browserLang : DEFAULT_LANG;
};

export const resolveLanguage = () => {
  const urlLang = getLanguageFromURL();
  if (urlLang) return urlLang;

  const userLang = getUserLanguage();
  if (userLang) return userLang;

  const browserLang = getBrowserLanguage();
  if (browserLang) return browserLang;

  return DEFAULT_LANG;
};

export const cacheLanguage = (lang) => {
  localStorage.setItem("i18nextLng", lang);
};
